__turbopack_context__.v({
  "creditNotes": "CreditNotesBlock-module-scss-module__AQiJNq__creditNotes",
});
